import React from 'react';
import StepProgress from 'components/StepProgress';

import './styles.scss';

const steps: any = [
    { description: 'Schedule', value: 1 },
    { description: 'Area', value: 2 },
    { description: 'Application', value: 3 },
    { description: 'Equipment', value: 4 },
    { description: 'Product', value: 5 },
    { description: 'Summary', value: 6 }
];

export default class StyleGuide extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            selectedStep: 1
        };
    }

    render(): React.ReactElement {
        const { selectedStep } = this.state;

        return (
            <div className="style-guide">
                <header className="style-guide-header">
                    <h1 className="title">Style Guide</h1>
                </header>
                <section className="style-guide-section">
                    <header className="style-guide-section-header">
                        <h2 className="title">Step progress</h2>
                    </header>
                    <StepProgress
                        steps={steps}
                        selectedStep={selectedStep}
                        setSelectedStep={(step: any) =>
                            this.setState({ selectedStep: step })
                        }
                    />
                </section>
            </div>
        );
    }
}
